import React from 'react';
import './auth-btns.css';

const AuthBtns = () => {
  return (
    <div className='auth-btns'>
      <button className='btn'>sign up</button>
      <button className='btn btn-outline'>log in</button>
    </div>
  );
};

export default AuthBtns;
